import { render, staticRenderFns } from "./InventoryHome.vue?vue&type=template&id=d689984e&scoped=true&lang=pug&"
import script from "./InventoryHome.vue?vue&type=script&lang=js&"
export * from "./InventoryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d689984e",
  null
  
)

export default component.exports